export default {
  notifyUsers: 'Siųsti pranešimą, jog pietūs buvo pridėti',
  date: 'Data',
  providers: 'Tiekėjai',
  touchDeviceTooltip: 'Ilgai spustelėjus tiekėją gaunamas kontekstinis meniu.',
  desktopTooltip: 'Dešiniu pelės klavišu spustelėjus ant tiekėjo gaunamas kontekstinis meniu.',
  ordersCount: '{count} Užsakymas(ai)',
  notApproved: 'Tiekėjas dar nepatvirtintas',
  approve: 'Patvirtinti',
  noProviders: 'Nėra tiekėjų.',
  startBy: 'Pradėti ',
  cannotAddAnyMore: 'Negalima pridėti tiekėjų į praeitį.',
  addingOne: 'pridedant naują.',
  settings: 'Nustatymai',
  freeOfCharge: 'Nemokami pietūs',
  comment: 'Komentaras',
  copyModalTitle: 'Pasirinkite dieną, ir tiekėją',
  copyModalSubtitle: 'Bus atidarytas redagavimo langas.',
  noProvidersFound: 'Tiekėjų nerasta.',
  dishes: '{count} patiekalai',
  addProvider: 'Pridėti naują tiekėją.',
  getLink: 'Gauti nuorodą tiekėjo pridėjimui.',
  copyProvider: 'Kopijuoti tiekėją iš kitos dienos.',
  providerSettings: 'Tiekėjo Nustatymai',
  categories: 'Kategorijos',
  providerName: 'Tiekėjo Pavadinimas',
  color: 'Spalva',
  providerColor: 'Tiekėjo spalva',
  categoryName: 'Kateg. Pavadinimas',
  translation: 'Vertimas',
  soups: 'Sriubos',
  mains: 'Pagrindiniai Patiekalai',
  dish: 'Patiekalas',
  multiple: '(Sudėtinis)',
  selectionName: 'Patiekalo pavadinimas',
  orderUntilDay: 'Priimama iki (Dienos)',
  orderUntilHour: 'Priimama iki (Valandos)',
  category: '{category} kategorija',
  createLink: 'Sukurti Nuorodą Naujo Tiekėjo Pridėjimui',
  selectedWeek: 'Parinkta savaitė',
  link: 'Nuoroda',
  generateLink: 'Generuoti Nuorodą',
  succesfullySaved: 'Tiekėjas sėkmingai išsaugotas.',
  promptDishRatings: 'Priminti Vartotojams Įvertinti Pietus',
  unableToEdit: 'Negalima redaguoti praėjusios savaitės duomenų.',
  unableToDeleteProvider: 'Negalima trinti tiekėjo, kadangi jis turi užsakymų arba yra praėjusioje savaitėje.',
  unableToDeleteDish: 'Pašalinti patiekalo negalima, nes jis jau yra užsakytas ({count} užsakymų)',
  invalidFields: 'Formoje yra neteisingai užpildytų laukų: {fields}',
  emptyCategories: 'Formoje yra tuščių kategorijų, pridėkite patiekalų arba pašalinkite šias kategorijas: {categories}',
  manageProviders: 'Valdyti tiekėjus',
};
